/**
 * IO Sticky ATC experiment helpers (unpublished theme).
 * - UTM session persistence
 * - CONTROL/TEST assignment (no live 50/50)
 * - Custom event publish + QA buffer
 */
(function () {
  'use strict';

  var EXPERIMENT = 'sticky_atc';
  // Deploy-clone / MAIN Phase 1 default = CONTROL.
  // Force TEST only with ?io_sticky_atc=test (staff QA). Ordinary visitors stay CONTROL.
  var DEFAULT_VARIANT = 'control';
  var LS_VARIANT = 'io_sticky_atc_variant';
  var LS_UTM = 'io_acq_utm_v1';
  var LS_SID = 'io_exp_sid';
  var SS_PENDING_ATC = 'io_pending_atc';
  var SS_FIRED = 'io_exp_fired_';

  function nowIso() {
    try { return new Date().toISOString(); } catch (e) { return ''; }
  }

  function safeParse(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function getQuery() {
    try { return new URLSearchParams(window.location.search || ''); } catch (e) { return new URLSearchParams(); }
  }

  function deviceBucket(w) {
    w = Number(w) || 0;
    if (w <= 320) return 'mobile_320';
    if (w <= 375) return 'mobile_375';
    if (w <= 430) return 'mobile_430';
    if (w <= 767) return 'mobile';
    if (w <= 1024) return 'tablet';
    return 'desktop';
  }

  function ensureSessionId() {
    var sid = null;
    try { sid = localStorage.getItem(LS_SID); } catch (e) {}
    if (!sid) {
      sid = 'io_' + Math.random().toString(36).slice(2, 10) + '_' + Date.now().toString(36);
      try { localStorage.setItem(LS_SID, sid); } catch (e2) {}
    }
    return sid;
  }

  function readUtmsFromUrl() {
    var q = getQuery();
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var out = {};
    var any = false;
    keys.forEach(function (k) {
      var v = q.get(k);
      if (v != null && String(v).trim() !== '') {
        out[k] = String(v).trim();
        any = true;
      }
    });
    return any ? out : null;
  }

  function loadStoredUtms() {
    try {
      var raw = sessionStorage.getItem(LS_UTM);
      if (!raw) raw = localStorage.getItem(LS_UTM);
      var data = safeParse(raw);
      if (!data || typeof data !== 'object') return {};
      return data;
    } catch (e) {
      return {};
    }
  }

  function persistUtms(utms) {
    if (!utms) return;
    var payload = {
      utm_source: utms.utm_source || '',
      utm_medium: utms.utm_medium || '',
      utm_campaign: utms.utm_campaign || '',
      utm_content: utms.utm_content || '',
      utm_term: utms.utm_term || '',
      captured_at: nowIso(),
      landing_path: (window.location.pathname || '') + (window.location.search || '')
    };
    var raw = JSON.stringify(payload);
    try { sessionStorage.setItem(LS_UTM, raw); } catch (e) {}
    try { localStorage.setItem(LS_UTM, raw); } catch (e2) {}
  }

  function initUtms() {
    var fromUrl = readUtmsFromUrl();
    if (fromUrl) {
      // New campaign visit with any UTM present → replace stored acquisition UTMs
      persistUtms(fromUrl);
      return loadStoredUtms();
    }
    // No UTMs on this URL → keep prior session/local acquisition UTMs (do not overwrite with blanks)
    return loadStoredUtms();
  }

  function resolveVariant() {
    var q = getQuery();
    var forced = (q.get('io_sticky_atc') || '').toLowerCase();
    if (forced === 'clear' || forced === 'reset') {
      try { localStorage.removeItem(LS_VARIANT); } catch (e) {}
      try { sessionStorage.removeItem(LS_VARIANT); } catch (e2) {}
      forced = '';
    }
    if (forced === 'control' || forced === 'test') {
      try { sessionStorage.setItem(LS_VARIANT, forced); } catch (e3) {}
      try { localStorage.setItem(LS_VARIANT, forced); } catch (e4) {}
      return forced;
    }
    var stored = null;
    try { stored = sessionStorage.getItem(LS_VARIANT) || localStorage.getItem(LS_VARIANT); } catch (e5) {}
    if (stored === 'control' || stored === 'test') return stored;
    return DEFAULT_VARIANT;
  }

  function readProductContext() {
    var el = document.getElementById('io-exp-product-context');
    if (el && el.textContent) {
      var parsed = safeParse(el.textContent);
      if (parsed) return parsed;
    }
    return {
      product_id: null,
      variant_id: null,
      product_handle: null,
      product_title: null,
      template: (document.body && document.body.className.match(/template-([\w-]+)/) || [])[1] || null,
      decoration_required: !!(document.getElementById('io-decorate-btn') || document.querySelector('[data-io-sticky-customize]'))
    };
  }

  function currentVariantId() {
    var form = document.querySelector('form.io-product-form');
    if (!form) return null;
    var sel = form.querySelector('select[data-io-variant-select]');
    if (sel && sel.value) return sel.value;
    var hidden = form.querySelector('input[data-io-variant-select][type="hidden"]');
    if (hidden && hidden.value) return hidden.value;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    return null;
  }

  function buildPayload(extra) {
    var utm = window.__IO_UTM || loadStoredUtms() || {};
    var ctx = readProductContext();
    var w = window.innerWidth || 0;
    var payload = {
      experiment: EXPERIMENT,
      sticky_variant: window.__IO_STICKY_VARIANT || resolveVariant(),
      product_id: ctx.product_id,
      variant_id: currentVariantId() || ctx.variant_id || null,
      product_handle: ctx.product_handle,
      product_title: ctx.product_title,
      template: ctx.template,
      decoration_required: !!ctx.decoration_required,
      viewport_width: w,
      device_bucket: deviceBucket(w),
      utm_source: utm.utm_source || '',
      utm_medium: utm.utm_medium || '',
      utm_campaign: utm.utm_campaign || '',
      utm_content: utm.utm_content || '',
      utm_term: utm.utm_term || '',
      session_id: ensureSessionId(),
      page_path: window.location.pathname || '',
      ts: nowIso()
    };
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
    }
    return payload;
  }

  function onceKey(name) {
    return SS_FIRED + name + ':' + (window.location.pathname || '');
  }

  function hasFired(name) {
    try { return sessionStorage.getItem(onceKey(name)) === '1'; } catch (e) { return false; }
  }

  function markFired(name) {
    try { sessionStorage.setItem(onceKey(name), '1'); } catch (e) {}
  }

  function publish(eventName, extra, opts) {
    opts = opts || {};
    if (opts.once && hasFired(eventName)) return false;
    var payload = buildPayload(extra);
    window.__IO_EVENTS = window.__IO_EVENTS || [];
    window.__IO_EVENTS.push({ event: eventName, payload: payload, at: nowIso() });
    try {
      window.dispatchEvent(new CustomEvent('io:exp', { detail: { event: eventName, payload: payload } }));
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
      }
    } catch (e2) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    } catch (e3) {}
    if (opts.once) markFired(eventName);
    return true;
  }

  function markPendingAddToCart(extra) {
    var payload = buildPayload(extra);
    payload.pending = true;
    try { sessionStorage.setItem(SS_PENDING_ATC, JSON.stringify(payload)); } catch (e) {}
  }

  function confirmPendingAddToCart() {
    var raw = null;
    try { raw = sessionStorage.getItem(SS_PENDING_ATC); } catch (e) {}
    if (!raw) return;
    var pending = safeParse(raw);
    try { sessionStorage.removeItem(SS_PENDING_ATC); } catch (e2) {}
    if (!pending) return;
    // Verify cart contains the variant when possible
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var ok = true;
        if (cart && pending.variant_id) {
          ok = (cart.items || []).some(function (it) {
            return String(it.variant_id) === String(pending.variant_id);
          });
        }
        if (!ok) return;
        var pendingSource = pending.source || pending.cta_source || '';
        var ctaSource = 'primary';
        if (pendingSource === 'sticky_submit' || pendingSource === 'sticky') ctaSource = 'sticky';
        else if (pendingSource === 'product_form_submit' || pendingSource === 'primary') ctaSource = 'primary';
        publish('io_add_to_cart', {
          product_id: pending.product_id || null,
          product_handle: pending.product_handle || null,
          product_title: pending.product_title || null,
          template: pending.template || null,
          decoration_required: !!pending.decoration_required,
          variant_id: pending.variant_id,
          confirmed: true,
          source: 'cart_confirm',
          cta_source: ctaSource
        }, { once: true });
      })
      .catch(function () {
        // If cart.js fails, still do not invent success
      });
  }

  function bindCheckoutStarted() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!/\/checkouts?\b/i.test(href) && !/\/checkout(\?|$|#)/i.test(href) && !/shop\.app\/checkout/i.test(href)) return;
      publish('io_checkout_started', { href: href.split('?')[0] }, { once: true });
    }, true);
    document.addEventListener('submit', function (e) {
      var t = e.target;
      if (!t) return;
      var action = (t.getAttribute('action') || '');
      var sub = e.submitter;
      if (action.indexOf('/checkout') !== -1 || (sub && sub.getAttribute('name') === 'checkout')) {
        publish('io_checkout_started', { source: 'form' }, { once: true });
      }
    }, true);
  }

  function bindFormPendingAtc() {
    var form = document.querySelector('form.io-product-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var vid = currentVariantId();
      if (!vid) return;
      // Sticky ATC calls requestSubmit(primary); do not overwrite sticky origin.
      try {
        var raw = sessionStorage.getItem(SS_PENDING_ATC);
        var pending = raw ? safeParse(raw) : null;
        if (pending && (pending.source === 'sticky_submit' || pending.cta_source === 'sticky')) {
          pending.variant_id = vid;
          pending.pending = true;
          sessionStorage.setItem(SS_PENDING_ATC, JSON.stringify(pending));
          return;
        }
      } catch (e) {}
      markPendingAddToCart({ variant_id: vid, source: 'product_form_submit', cta_source: 'primary' });
    });
  }

  function onPdp() {
    var ctx = readProductContext();
    if (!ctx.product_id && !document.querySelector('form.io-product-form')) return;
    publish('io_pdp_view', {}, { once: true });
    bindFormPendingAtc();
  }

  // Public API for sticky script
  window.IOExp = {
    experiment: EXPERIMENT,
    getVariant: function () { return window.__IO_STICKY_VARIANT || resolveVariant(); },
    isTest: function () { return this.getVariant() === 'test'; },
    isControl: function () { return this.getVariant() === 'control'; },
    publish: publish,
    markPendingAddToCart: markPendingAddToCart,
    buildPayload: buildPayload,
    deviceBucket: deviceBucket
  };

  window.__IO_UTM = initUtms();
  window.__IO_STICKY_VARIANT = resolveVariant();
  ensureSessionId();

  function boot() {
    onPdp();
    bindCheckoutStarted();
    if (/\/cart(\/|$)/.test(window.location.pathname || '')) {
      confirmPendingAddToCart();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
